<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-xs-12 col-md-6 vcenter">
      <h3>{{oaProjectName}}s</h3>
    </div>
  </div>

  <hr style="margin-top:2px;margin-bottom:2px" />

  <div class="row top10">
    <aims-common-table
      id="oas-table"
      [dataSource]="oas | async"
      [header]="tableHeader"
      [permissions]="tablePermissions"
      [defaultTableState] = "{ sort:{ active : 'noticeToProceedDate', direction: 'desc' }}"
      pageSize="10"
      [stickyHeader]="true">

      <aims-common-table-dynamic-row id="proposalPrice">
        <ng-template viewMode let-element >
           {{ element.proposalPrice | currency: "USD":"symbol":"1.2-4" }}
        </ng-template>
      </aims-common-table-dynamic-row>

      <aims-common-table-dynamic-row id="approvedPrice">
        <ng-template viewMode let-element >
           {{ element.approvedPrice | currency: "USD":"symbol":"1.2-4" }}
        </ng-template>
      </aims-common-table-dynamic-row>

      <aims-common-table-dynamic-row id="overHead">
        <ng-template viewMode let-element >
           {{ element.overHead | currency: "USD":"symbol":"1.2-4" }}
        </ng-template>
      </aims-common-table-dynamic-row>

      <aims-common-table-dynamic-row id="purchases">
        <ng-template viewMode let-element >
           {{ element.purchases | currency: "USD":"symbol":"1.2-4" }}
        </ng-template>
      </aims-common-table-dynamic-row>

      <aims-common-table-dynamic-row id="labor">
        <ng-template viewMode let-element >
           {{ element.labor | currency: "USD":"symbol":"1.2" }}
        </ng-template>
      </aims-common-table-dynamic-row>

      <aims-common-table-dynamic-row id="travel">
        <ng-template viewMode let-element >
           {{ element.travel | currency: "USD":"symbol":"1.2-4" }}
        </ng-template>
      </aims-common-table-dynamic-row>

      <aims-common-table-dynamic-row id="totalCosts">
        <ng-template viewMode let-element >
          {{ (element.overHead + element.labor + element.purchases + element.travel) | currency }}
        </ng-template>
      </aims-common-table-dynamic-row>

      <aims-common-table-dynamic-row id="profitDollars">
        <ng-template viewMode let-element >
          {{ element.approvedPrice - (element.overHead + element.labor + element.purchases + element.travel) | currency }}
        </ng-template>
      </aims-common-table-dynamic-row>

      <aims-common-table-dynamic-row id="profitPercent">
        <ng-template viewMode let-element >
          {{ (element.approvedPrice - (element.overHead + element.labor + element.purchases + element.travel))/element.approvedPrice | percent:'1.0-2' }}
        </ng-template>
      </aims-common-table-dynamic-row>
    </aims-common-table>

  </div>
</div>
